import TicketsCount from "components/conventions/TicketsCount"
import { useConventionRegistration } from "contexts/ConventionRegistrationContext"
import React from "react"

interface LaunchpadTicketsCountProps {
  className?: string
}

const LaunchpadTicketsCount = (props: LaunchpadTicketsCountProps) => {
  const { className } = props
  const conventionRegistration = useConventionRegistration()

  return (
    <TicketsCount
      className={className}
      convention={conventionRegistration.convention}
      conventionRegistration={conventionRegistration.conventionRegistration!}
    />
  )
}

export default LaunchpadTicketsCount
